import { SIDEBAR } from 'analytics/constants/ids';
import { SidebarEventLabels } from 'analytics/constants/labels';

import { trackClick } from 'services/Analytics';

export const trackSidebarLinkClick = (eventAction: SidebarEventLabels) =>
    trackClick(SIDEBAR, { event_action: eventAction });
